import { render, staticRenderFns } from "./DocumentFollowupIFrame.vue?vue&type=template&id=daf14cf4"
import script from "./DocumentFollowupIFrame.vue?vue&type=script&lang=js"
export * from "./DocumentFollowupIFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports